import {Injectable} from '@angular/core';
import {BaseService} from '../../../services/base.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';

import {AuthService} from '../../../services/auth.service';
import {Wishlist} from '../models/Wishlist/Wishlist';
import {Subject} from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class WishlistService extends BaseService {

    wishList: Wishlist = null ;

    private ItemAddedToWishListEventEmitter = new Subject<string>();
    private WishListUpdatedEventEmitter = new Subject<Wishlist>();


    public ItemAddedToWishListEvent$ = this.ItemAddedToWishListEventEmitter.asObservable();
    public WishListUpdatedEvent$ = this.WishListUpdatedEventEmitter.asObservable();


    constructor(private httpClient: HttpClient,
                private authService: AuthService) {
        super();
    }

    getCustomerWishlist() {

        const serviceURL = this.baseAPI + 'adham/wishlist';

        return this.httpClient.get<Wishlist>(serviceURL, this.authService.getHttpOptions());
    }

    addWishlistItem(sku) {

        const serviceURL = this.baseAPI + 'adham/wishlist/' + sku;
        return this.httpClient.put<any>(serviceURL, {}, this.authService.getHttpOptions());

    }

    removeWishlistItem(sku) {

        const serviceURL = this.baseAPI + 'adham/wishlist/' + sku;
        return this.httpClient.delete<any>(serviceURL, this.authService.getHttpOptions());

    }

    removeWishlistItem2(customer_id,item_id) {

        let obj = {
            customer_id: customer_id,
            item_id: item_id
        }
        const serviceURL = this.baseAPI2 + '/mage/wishlist/deleteitem';
        return this.httpClient.post<any>(serviceURL,obj, this.authService.getHttpOptions());

    }

    /***** events **/
    EmitItemAddedToWishList(sku: string) {
        this.ItemAddedToWishListEventEmitter.next(sku);
    }

    EmitWishListUpdated(wishlist : Wishlist) {
        this.WishListUpdatedEventEmitter.next(wishlist);
    }


}
